import axios from "axios";
import VueCookie from "vue-cookie";
import router from "../routes/router";
const qs = require("querystring");

let axiosInstance = axios.create({
  //  baseURL: getBaseUrl(),
  timeout: 120000
});

axiosInstance.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    if (
      error.response?.status === 401 &&
      error.response.data.message != "Invalid reCAPTCHA"
    ) {
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

class HttpRequest {
  constructor() {
    axios.defaults.baseURL = this.getBaseUrl();
    this.axios = axios;
  }

  getBaseUrl() {
    if (process.env.NODE_ENV !== "development") {
      return "";
      // return "https://onecall.test.dtac.co.th";
    } else {
      // return "https://onecall.test.dtac.co.th";
      return "http://localhost";
    }
  }

  setHeader(header) {
    // axiosInstance.defaults.headers.common[header.key] = header.value
    axiosInstance.defaults.headers.common["Authorization"] = VueCookie.get(
      "token"
    );
    axiosInstance.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
  }

  fetch(methodName, data) {
    return axiosInstance.get(methodName, {
      params: data
    });
  }

  create(methodName, data) {
    return axiosInstance.post(methodName, data);
  }

  post(methodName, data) {
    return axiosInstance.post(
      this.getBaseUrl() + "/api/portal/" + methodName,
      qs.stringify(data),
      {
        headers: { Authorization: "Bearer " + VueCookie.get("token") }
      }
    );
  }

  postJson(methodName, data) {
    return axiosInstance.post(
      this.getBaseUrl() + "/api/portal/" + methodName,
      data,
      {
        headers: {
          Authorization: "Bearer " + VueCookie.get("token"),
          "Content-Type": "application/json"
        }
      }
    );
  }

  // Multipart upload. `config` is optional and is spread AFTER the defaults, so
  // a caller may override any of them — in practice `timeout` and
  // `onUploadProgress`. The existing caller (ImportNumberTables) passes nothing
  // and behaves exactly as before.
  //
  // The instance-wide 120 s timeout is a guess about a form post, not about a
  // file: the voicemail restore upload is a corporate's whole voicemail archive
  // (hundreds of megabytes — base64 recordings inside the XML documents plus a
  // wav per message), and 120 s would abort it mid-body on any ordinary link.
  // That caller passes `timeout: 0`. Note what that does NOT do: the real limit
  // on an upload this size is nginx's client_max_body_size and
  // proxy_read_timeout in front of the API, which is a deploy matter and cannot
  // be set from here.
  postFile(methodName, data, config) {
    return axiosInstance.post(
      this.getBaseUrl() + "/api/portal/" + methodName,
      data,
      {
        headers: {
          Authorization: "Bearer " + VueCookie.get("token"),
          "Content-Type": "multipart/form-data"
        },
        ...config
      }
    );
  }

  // postBlob hits an endpoint that streams a file back (e.g. .xlsx exports).
  // The response body is a Blob and the caller is expected to convert it to
  // an object URL and trigger a download.
  postBlob(methodName, data) {
    const qs = require("qs");
    return axiosInstance.post(
      this.getBaseUrl() + "/api/portal/" + methodName,
      qs.stringify(data || {}),
      {
        headers: {
          Authorization: "Bearer " + VueCookie.get("token"),
          "Content-Type": "application/x-www-form-urlencoded"
        },
        responseType: "blob"
      }
    );
  }

  // getBlob is the GET twin of postBlob, for an endpoint that streams a file
  // back in answer to query parameters rather than a form body (the voicemail
  // backup download). `get` cannot be reused for it: without
  // responseType "blob" axios decodes the zip as text and hands back a
  // corrupted body that still looks like a success.
  getBlob(methodName, data) {
    return axiosInstance.get(this.getBaseUrl() + "/api/portal/" + methodName, {
      params: data,
      headers: { Authorization: "Bearer " + VueCookie.get("token") },
      responseType: "blob"
    });
  }

  post_guest(methodName, data) {
    return axiosInstance.post(
      this.getBaseUrl() + methodName,
      qs.stringify(data)
    );
  }

  // Authenticated POST to an absolute path. `post` prefixes /api/portal/, which
  // is right for the business endpoints but wrong for the /api/auth/* routes
  // that still need the bearer token: logout has to present it so the server
  // knows which JWT_<token> key to drop (#50). Passing an /api/auth path to
  // `post` instead produced /api/portal//api/auth/logout, which matches no
  // route and was answered 401 by the group's catch-all.
  post_auth(methodName, data) {
    return axiosInstance.post(
      this.getBaseUrl() + methodName,
      qs.stringify(data),
      {
        headers: { Authorization: "Bearer " + VueCookie.get("token") }
      }
    );
  }

  get(methodName, data) {
    if (!methodName.startsWith("/"))
      methodName = this.getBaseUrl() + "/api/portal/" + methodName;

    return axiosInstance.get(methodName, {
      params: data,
      headers: { Authorization: "Bearer " + VueCookie.get("token") }
    });
  }

  update(methodName, data) {
    return axiosInstance.put(methodName, data);
  }

  delete(methodName, id) {
    return axiosInstance.delete(methodName, { params: { id: id } });
  }

  request(type, url, data) {
    let promise = null;
    switch (type) {
      case "GET":
        promise = axios.get(url, { params: data });
        break;
      case "POST":
        promise = axios.post(url, data);
        break;
      case "PUT":
        promise = axios.put(url, data);
        break;
      case "DELETE":
        promise = axios.delete(url, data);
        break;
      default:
        promise = axios.get(url, { params: data });
        break;
    }
    return promise;
  }
}

export default HttpRequest;
